<template>
  <label>
    <input type="checkbox"
      class="hidden-checkbox"
      :value="value"
      :checked="isChecked"
      @change="handleChange">
    <template v-if="isChecked">
      <slot name="on">
        <span>ON</span>
      </slot>
    </template>
    <template v-else>
      <slot name="off">
        <span>OFF</span>
      </slot>
    </template>

    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'checkbox',

  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    value: {
      default: true
    },

    uncheckedValue: {
      default: false
    },

    checked: {
      default: false
    }
  },

  computed: {
    isChecked () {
      return this.checked === this.value
    }
  },

  methods: {
    handleChange ({ target: { checked } }) {
      this.$emit('change', checked ? this.value : this.uncheckedValue)
    }
  }
}
</script>

<style lang="sass">
  .hidden-checkbox
    display: none
</style>



// WEBPACK FOOTER //
// src/components/ui/Checkbox.vue